// extracted by mini-css-extract-plugin
module.exports =  {"title":"_0bc5e8de02--title--SpFgc","filter":"_0bc5e8de02--filter--oEtoy","wrapper":"_0bc5e8de02--wrapper--DSAzW","scrollable":"_0bc5e8de02--scrollable--L0N_w"};